const colors = {
  "navy100": "#002153",
  "navy80": "#334d78",
  "navy60": "#667a9a",
  "navy40": "#99a6bb",
  "navy20": "#ccd3dd",
  "blue100": "#3f79e0",
  "blue60": "#8cafec",
  "blue40": "#aac9f5",
  "blue20": "#d5e4fa",
  "aqua100": "#07bcf4",
  "aqua60": "#6ad7f8",
  "aqua40": "#9ce4fb",
  "aqua20": "#cdf2fd",
  "white100": "#fff",
  "sky100": "#f0f5fc",
  shadow: "rgba(0, 33, 83, 0.1)",
  "green100": "#02c685",
  "green60": "#67ddb6",
  "green40": "#99e9cc",
  "red100": "#e26159",
  "red60": "#eea19c",
  "red40": "#fabbba",
  "yellow100": "#efcb37",
  "yellow60": "#f1dc83",
  "yellow40": "#fce999",
  "orange100": "#d98f46",
  "purple100": "#6b3cc1",
  "purple60": "#a68ada",
};

export default colors;
